<template>
  <div>
    <ul class="content">
      <li v-show="data != ''" v-for="(item, k) in data" :key="k">
        <h3>{{ item.title }}</h3>
        <p>{{ item.create_time.substring(0, 10) }}</p>
      </li>
      <li v-show="data == ''" class="noData">
        <p>暂无</p>
      </li>
    </ul>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: false,
      data: "",
      page: 1,
      pagination: {}
    };
  },
  mounted() {
    this.getData(); //获取数据
  },
  methods: {
    getData() {
      let url =
        this.httpsBasic.url + this.httpsBasic.message + "Message/queryMessage";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          page: this.page
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  height: 230px;
  overflow-y: scroll;
  padding-right: 10px;
  > li {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    padding: 8px 0;
    p,
    h3 {
      display: inline-block;
      font-size: 12px;
      color: #666;
      font-weight: normal;
      vertical-align: top;
      margin: 0;
      text-align: justify;
    }
    h3 {
      max-width: 70%;
    }
  }
  .noData {
    text-align: center;
    border: none;
    p {
      text-align: center;
    }
  }
}
</style>
